import * as React from "react";
import { Eye, EyeOff } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Input } from "./ui/input";

// Champ mot de passe avec un bouton « œil » pour révéler / masquer la saisie.
// Mêmes props qu'un <Input> ; `leftIcon` (optionnel) affiche une icône à gauche.
export function PasswordInput({ className, leftIcon, ...props }) {
  const { t } = useTranslation();
  const [show, setShow] = React.useState(false);
  return (
    <div className="relative">
      {leftIcon}
      <Input
        {...props}
        type={show ? "text" : "password"}
        className={(leftIcon ? "pl-10 " : "") + "pr-10 " + (className || "")}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        tabIndex={-1}
        aria-label={show ? t("common.hidePassword") : t("common.showPassword")}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-zinc-500 hover:text-zinc-200"
      >
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
}

export default PasswordInput;
